import styled from "styled-components";
import { Color, Device } from "@styles/constants";
import { rem } from "@styles/helpers";

export const Summary = styled.div`
  background: ${Color.white};
  box-shadow: 0 -1px 15px 0 rgb(0 0 0 / 20%);
  padding-top: ${rem(16)};
  margin: ${rem(30)} 0;

  header,
  main {
    padding: 0 ${rem(25)};

    @media ${Device.small} {
      padding: 0 ${rem(16)};
    }
  }

  main {
    margin: ${rem(16)} 0;
    position: relative;

    &:after {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      width: 90%;
      left: 5%;

      @media ${Device.small} {
        width: 95%;
        left: 2.5%;
      }
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: left;
    padding-bottom: ${rem(16)};
    position: relative;
    border-bottom: 0;

    &:after {
      border-bottom: 1px solid ${Color.black40};
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      width: 90%;
      left: 5%;

      @media ${Device.small} {
        width: 100%;
        left: 0;
      }
    }

    h3 {
      margin-bottom: 0;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    &.totals {
      li {
        line-height: 20px;
        justify-content: space-between;
      }
    }
  }

  .line-items {
    margin-top: ${rem(10)};
    padding-bottom: ${rem(15)};

    li {
      width: 100%;
      display: grid;
      grid-template-columns: min-content 1fr min-content;

      &:not(:last-of-type) {
        padding-bottom: ${rem(16)};
      }
    }

    .item-title {
      @media ${Device.mediumDown} {
        padding-right: ${rem(10)};
      }
    }

    .item-desc {
      width: 100%;
      font-size: ${rem(14)};
      margin-top: ${rem(6)};
      margin-bottom: 0;
      line-height: 1.125;
      color: ${Color.black60};
      grid-column: 2;
      order: 3;
      padding-right: ${rem(20)};

      @media ${Device.mediumDown} {
        grid-column: 2 / span 2;
        grid-row: 3;
        padding-right: 0;
      }

      &.bundle {
        white-space: pre;
      }
    }

    .item-price {
      grid-row: 1;
      grid-column: 3;
    }

    .item-variant {
      text-align: right;
      white-space: nowrap;
      grid-column: 3;
      grid-row: 2;

      @media ${Device.mediumDown} {
        grid-column: 2 / span 2;
      }
    }
  }

  .price {
    text-align: right;
    white-space: nowrap;

    &.total {
      font-weight: bold;
    }
  }

  .charge {
    h4 {
      margin-bottom: 0;
    }
  }

  .totals {
    padding: 0 ${rem(25)};
    margin-bottom: ${rem(8)};

    li > div {
      padding-bottom: ${rem(8)};
    }
  }

  .savings {
    p {
      margin-bottom: 0;
      white-space: pre-wrap;
    }

    background-color: ${Color.black100};
    color: ${Color.white};
    padding: ${rem(17)} ${rem(24)};

    .savings-header {
      line-height: ${rem(20)};
      font-weight: bold;
      width: 100%;

      .price {
        float: right;
      }
    }

    .promo-description {
      margin-top: ${rem(5)};
      font-size: ${rem(14)};
    }
  }

  .savings-mobile {
    border-radius: 3px;
  }

  @media ${Device.mediumDown} {
    width: 100%;
    border-bottom: 1px solid ${Color.black40};
    box-shadow: inset 0 7px 7px 0px rgba(0, 0, 0, 0.3);
  }
`;

export const PriceWrapper = styled.div`
  margin-bottom: ${rem(5)};
`;

export const Price = styled.span`
  float: right;
`;

export const P = styled.p`
  margin-bottom: ${rem(5)};
  font-size: inherit;
  line-height: 1.6;
  text-rendering: optimizeLegibility;
`;
